module.exports = __webpack_public_path__ + "static/img/3.3f8af14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/soft/3.jpg
// module id = JdNb
// module chunks = 13